import React from "react";
import "../Styles/Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <span className="load"></span>
    </div>
  );
};

export default Loader;
